module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Adresat")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Adres e-mail adresata",
      "name": "send_to",
      "type": "text",
      "validation-rules": "required|email",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz e-mail adresata wiadomości"
    },
    model: {
      value: (_vm.send_to),
      callback: function($$v) {
        _vm.send_to = $$v
      },
      expression: "send_to"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.send_to
    }
  }, [_vm._v("Wyślij testową wiadomość")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ba4d7cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/TestForm.vue
// module id = 237
// module chunks = 0